<template>
  <div class="emp-modal show -overlay" @click="close($event)" :class="{ '-light': $attrs.data.type == 'PLANT' }">
    <div class="content" :class="{ '-regua': $attrs.data.type === 'REGUA' }">
      <header class="modal-top-bar" :class="{ '-light': $attrs.data.type == 'PLANT' }">
        <div class="btns-left -highlights">
          <a v-if="$attrs.data.type !== 'REGUA'" :href="urlFiles + 'cliente/status-obra/' + downloadURL" class="-btn btn-save" download target="_blank">Salvar</a>
        </div> <!-- /.btns-left -->

        <a href="javascript:void(0)" class="btn-close" @click="$emit('close', true)"></a>
      </header>

      <div class="content-modal" v-if="$attrs.data.type === 'GALLERY'">
        <a href="javascript:void(0)" class="btn btn-prev" @click="prevSlide()"></a>

        <swiper class="-swiper" ref="swiperGallery" :options="swiperOption" @slideChange="slideChangedGallery()">
          <swiper-slide class="swiper-slide" v-for="item in $attrs.data.arr" :key="item.id">
            <figure>
              <div><img :src="urlFiles + $attrs.data.urlBase + (item.foto || item.arquivo || item[isMobile() ? 'arteMobile' : 'arteDesktop'])" :alt="item.legenda"></div>
              <figcaption>{{item.legenda}}</figcaption>
            </figure>
          </swiper-slide>
        </swiper> <!-- /swiper -->

        <a href="javascript:void(0)" class="btn btn-next" @click="nextSlide()"></a>
      </div>

      <div class="content-modal" v-if="$attrs.data.type === 'REGUA'">
        <h3>{{ $attrs.data.data.nome }}</h3>

        <p v-html="$attrs.data.data.conteudo"></p>
      </div> <!-- /.content-modal -->

      <template v-if="$attrs.data.type == 'PLANT'">
        <div class="content-modal -plant">
          <div class="tabs">
            <!-- <a href="javascript:void(0)" v-for="item in $attrs.data.arr" v-if="item.tipo === 'mapeada' && item.plantas" :key="item.id" :class="{ '-active': item.id === idActive }" @click="idActive = item.id">{{ item.titulo }}</a> -->
          </div>

          <div class="info">
            <div class="-swiper" ref="swiperPlant" :options="swiperOptionPlant" @slideChange="slideChangedPlant()">
              <figure class="swiper-slide" v-for="(item, i) in $attrs.data.arr" :key="item.id" v-if="activeIndex === i">
                <div>
                  <p v-for="(map, i) in item.mapeamentos" :key="map.id" :style="{ top: map.y + '%', left: map.x + '%' }" :class="{ '-active': currentHover == map.id }" @mouseover="currentHover = map.id" @mouseleave="currentHover = null">{{ i + 1 }}</p>

                  <img :src="urlFiles + 'emp/' + $attrs.empId + '/' + $attrs.data.grupo.blocoId + '/' + item.arquivo" :alt="''">
                </div>
              </figure> <!-- /figure -->
            </div> <!-- /.-swiper -->

            <!-- CASO SEJA GALERIA DE PLANTAS -->
            <ul class="list-items" v-for="(item, i) in $attrs.data.arr" :key="item.id" v-if="activeIndex === i">
              <li :data-index="i + 1" v-for="(map, i) in item.mapeamentos" :key="map.id" :class="{ '-active': currentHover == map.id }" @mouseover="currentHover = map.id" @mouseleave="currentHover = null">{{ map.item || '' }}</li>
            </ul> <!-- /.list-items -->

            <div class="arrows-mobile">
              <a href="javascript:void(0)" class="btn btn-prev" @click="prevSlidePlant()"></a>
              <a href="javascript:void(0)" class="btn btn-next" @click="nextSlidePlant()"></a>
            </div>
          </div>
        </div> <!-- /.content -->

        <div class="caption" v-for="(item, i) in $attrs.data.arr" :key="item.id" v-if="activeIndex === i && item.legenda">
          <p>{{ item.legenda || '' }}</p>
        </div>
      </template>

      <!-- <div class="caption" v-for="(item, i) in $attrs.data.arr" :key="item.id" v-if="i === activeIndex && item.legenda">
        <p>{{ item.legenda || '' }}</p>
      </div> -->
    </div> <!-- /.content -->
  </div> <!-- /.emp-modal -->
</template>

<script>
import Vue from 'vue'

export default {
  components: {
  },

  data () {
    const data = {
      displayShare: false,
      downloadURL: '',
      currentHover: '',

      swiperOption: {
        autoHeight: false,
        loop: false,
        allowTouchMove: true,
        grabCursor: false,
        centeredSlides: true,
        slidesPerView: 1,
        // preloadImages: true,
        // updateOnImagesReady: true,
        keyboard: {
          enabled: true,
          onlyInViewport: false
        }
      },

      swiperOptionPlant: {
        effect: 'fade',
        autoHeight: true,
        loop: false,
        allowTouchMove: true,
        grabCursor: false,
        centeredSlides: true,
        preloadImages: true,
        updateOnImagesReady: true,
        slidesPerView: 1,
        keyboard: {
          enabled: true,
          onlyInViewport: false
        },
        fadeEffect: {
          crossFade: true
        }
      },

      activeIndex: 0,

      urlFiles: Vue.prototype.urlFiles
    }

    return data
  }, // data()

  mounted () {
    // Caso seja modal de galeria
    if (this.$attrs.data.type === 'GALLERY') {
      this.activeIndex = this.$attrs.data.activeIndex

      this.slideTo(this.activeIndex)
      this.slideChangedGallery(true)
    }

    // Caso seja modal de plantas
    if (this.$attrs.data.type === 'PLANT') {
      this.activeIndex = this.$attrs.data.activeIndex
      this.currentPlant = this.$attrs.data.currentPlant

      // this.slideToPlant(this.activeIndex)
      // this.slideChangedPlant(true)

      setTimeout(() => {
        this.slideChangedPlant(true)
      }, 250)
    }

    // Caso seja modal de galeria
    if (this.$attrs.data.type === 'REGUA') {
    }

    document.addEventListener('keyup', this.escPress)
  }, // mounted()

  methods: {

    // #######################################################
    // ################## Slide Galerias
    // #######################################################
    prevSlide () {
      if (this.swiper.activeIndex == 0) this.slideTo(this.$attrs.data.arr.length - 1)
      else this.swiper.slidePrev()
    }, // prevSlide()

    nextSlide () {
      if (this.swiper.activeIndex == this.$attrs.data.arr.length - 1) this.slideTo(0)
      else this.swiper.slideNext()
    }, // nextSlide()

    slideTo (i) {
      this.swiper.slideTo(i)
    }, // slideTo()

    slideChangedGallery (update = null) {
      this.activeIndex = this.swiper.activeIndex

      let obj = this.$attrs.data.arr.find((item, i) => i === this.activeIndex)

      this.downloadURL = obj.foto
    }, // slideChangedGallery()

    // #######################################################
    // ################## Slide Plantas
    // #######################################################
    prevSlidePlant () {
      const slider = this.$refs.swiperPlant.swiper
      slider.slidePrev()
    }, // prevSlidePlant()

    nextSlidePlant () {
      const slider = this.$refs.swiperPlant.swiper
      slider.slideNext()
    }, // nextSlidePlant()

    slideToPlant (i) {
      const slider = this.$refs.swiperPlant.swiper
      slider.slideTo(i)
    }, // slideToPlant()

    slideChangedPlant (update = null) {
      if (this.$refs.swiperPlant) {
        let slider = this.$refs.swiperPlant.swiper

        this.activeIndex = slider.activeIndex

        let objGroup = this.$attrs.data.arr[0]

        if (objGroup) {
          let objPlanta = {}

          if (objGroup.plantas) objPlanta = objGroup.plantas.find((item, i) => i === this.activeIndex)

          if (objPlanta) {
            // this.currentDownloadURL = this.baseApi + '/emp/' + this.$attrs.empId + '/' + objGroup.blocoId + '/' + objPlanta.arquivo
            this.currentPlant = objPlanta.id
          }
        }

        if (update) {
          setTimeout(() => slider.update(), 500)
        }
      }
    }, // slideChangedPlant()

    // #######################################################
    // ################## Comuns
    // #######################################################
    escPress (ev) {
      if (ev.keyCode === 27 || ev.which === 27) return this.close(false)
    }, // escPress()

    close (ev) {
      if (!ev || ev.target.classList.contains('-overlay')) {
        document.removeEventListener('keyup', this.escPress, false)

        this.$emit('close', true)
      }
    }, // close()

    toggleShare () {
      this.displayShare = !this.displayShare
    },

    isMobile () {
      return screen.width <= 1024
    } // isMobile()
  }, // methods

  computed: {
    swiper () {
      return this.$refs.swiperGallery.swiper
    } // swiper()
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  .modal-top-bar
    width: 100%
    display: flex
    justify-content: space-between
    align-items: center
    height: 55px
    background: map-get($colors, gray)
    border-radius: 15px 15px 0 0
    position: relative !important

    &.-light
      background: #fff

    .btns-left
      margin-left: 10px
      display: flex
      align-items: center
      width: 310px

      &.-hide
        visibility: hidden

      > *
        display: inline-block
        transition: all 250ms ease

      .-btn
        font-family: 'Gotham-Book'
        font-weight: 600
        padding: 9px 25px
        text-transform: uppercase
        color: #fff
        letter-spacing: 1px
        font-size: 16px
        border-radius: 5px
        margin-right: 15px
        max-width: 300px

        // &.-hide
        //   display: none

        &.btn-save
          background: map-get($colors, primary)

          &:hover
            background: darken(map-get($colors, primary), 5%)

        &.btn-share
        background: #658eca

        &:hover
          background: darken(#658eca, 5%)

      .social
        position: absolute
        left: 140px
        display: flex
        overflow: hidden
        align-items: center

        &:before
          content: ''
          position: absolute
          background-image: url(~/images/icons/modal-shadow.png)
          background-size: cover
          top: -2px
          bottom: -1px
          right: 30px
          width: 100%
          pointer-events: none

        a
          display: inline-block
          margin-right: 12px

          &:last-of-type
            margin-right: 0

        a:not(.btn-back)
          width: 30px
          height: 30px
          display: inline-block
          background-size: contain
          background-repeat: no-repeat
          background-position: center

          &.-fb
            background-image: url(~/images/icons/modal-fb.png)

          &.-ig
            background-image: url(~/images/icons/modal-ig.png)

          &.-wpp
            background-image: url(~/images/icons/modal-whats.png)

        .btn-back
          background-image: url(~/images/icons/modal-back.png)
          background-repeat: no-repeat
          background-size: contain
          width: 41px
          height: 37px
          text-indent: -99999px

      .counter
        // margin-left: 200px
        color: #fff
        position: absolute
        left: 50%
        transform: translateX(-50%)

    h3
      position: absolute
      left: 50%
      transform: translateX(-50%)
      font-weight: 600
      font-size: 36px

    .btn-close
      // position: absolute
      // top: 50%
      // right: 10px
      // transform: translateY(-50%)
      margin-right: 10px
      margin-top: 3px
      width: 20px
      height: 20px
      background-color: map-get($colors, primary)
      border-radius: 5px
      background-image: url(~/images/icons/modal-close.png)
      background-size: 10px auto
      background-repeat: no-repeat
      background-position: center

  @media (max-width: 1024px)
    .modal-top-bar
      border-radius: 7px 7px 0 0
      padding-top: 26px
      height: auto
      padding-bottom: 10px

      .btns-left.-highlights
        width: 100%
        display: flex
        justify-content: space-between

        .-btn
          margin-right: 10px

        .social
          left: initial
          right: 10px

        .counter
          display: none

      h3
        display: none

      .btn-close
        width: 30px
        height: 30px
        top: -17px
        right: 5px
        position: absolute

  .emp-modal
    position: fixed
    width: 100%
    height: 100%
    top: 0
    right: 0
    bottom: 0
    left: 0
    background: rgba(#000, 0.5)
    z-index: 100000
    display: flex
    align-items: center
    justify-content: center

    figure
      figcaption
        width: 100%
        text-align: center
        color: #fff
        margin-top: 5px
        font-size: 13px

    &.-light
      .content .content-modal
        background: #fff

    .content
      $sideSpaces: 10px
      $sizeSquare: 150px
      // position: absolute
      max-width: 1500px
      width: 95vw;
      // height: 95vh
      border-radius: 15px
      box-shadow: 0 13px 21px rgba(1, 2, 1, .69)

      &.-regua
        width: 60vw

        .content-modal
          padding: 25px

          h3,
          p
            color: #fff

          h3
            text-align: center
            text-transform: uppercase
            margin-bottom: 15px
            font-size: 22px

          p
            font-size: 18px

      .content-modal
        background: map-get($colors, gray)
        padding: 0 $sideSpaces 10px $sideSpaces
        position: relative
        overflow: hidden

        .btn
          position: absolute
          top: 50%
          transform: translateY(-50%) rotate(45deg)
          transform-origin: 50% 50%
          border-radius: 20px
          width: $sizeSquare
          height: $sizeSquare
          z-index: 10
          background: map-get($colors, gray)

          &:before
            content: ''
            background-image: url(~/images/icons/arrow-prev-red.png)
            background-size: contain
            background-repeat: no-repeat
            width: 30px
            height: 47px
            position: absolute

          &.btn-prev
            left: calc(#{$sideSpaces} - 100px)

            &:before
              transform: rotate(-45deg)
              top: 15%
              left: 60%

          &.btn-next
            right: calc(#{$sideSpaces} - 100px)

            &:before
              top: 54%;
              left: 20%;
              transform: rotate(135deg);

        &.-plant
          width: 100%

          .tabs
            width: 100%
            display: block
            padding-top: 20px
            margin-bottom: 20px

            a
              display: inline-block
              background: #fff
              text-transform: uppercase
              font-size: 16px
              margin-right: 10px
              max-width: 20%
              border: 2px solid #000
              margin-bottom: 10px
              padding: 5px 10px
              line-height: 22px
              color: #000
              transition: all 150ms ease

              &.-active,
              &:hover
                color: #fff
                background: #658eca
                border-color: #658eca

          .info
            display: flex
            justify-content: space-between
            align-items: flex-start

            .-swiper
              position: relative
              z-index: 0
              width: 70%
              display: inline-block

              figure
                position: relative
                padding: 10px 0 15px

                div
                  background: #fff
                  position: relative

                  img
                    display: block
                    max-width: 100%
                    height: auto

                  p
                    $height: 25px
                    cursor: pointer
                    position: absolute
                    background: map-get($colors, primary)
                    width: $height
                    height: $height
                    border-radius: 100%
                    font-size: 14px
                    line-height: #{$height - 4px}
                    font-weight: 500
                    color: #000
                    transition: all 150ms ease
                    text-align: center
                    border: 2px solid transparent
                    transform: translate(-50%, -50%)

                    &.-active
                      $height: 40px
                      width: $height
                      height: $height
                      line-height: #{$height - 5px}
                      border-color: #000
                      font-size: 18px
                      z-index: 10

            .list-items
              width: 30%
              padding-left: 15px

              li
                cursor: pointer
                text-transform: uppercase
                border-bottom: 1px solid  #000
                padding: 10px 10px 11px
                font-size: 18px
                position: relative
                z-index: 10

                &:last-of-type
                  border-bottom: none

                &:after
                  content: ''
                  position: absolute
                  left: 0
                  top: 4px
                  right: 0
                  bottom: 4px
                  z-index: -1
                  border-radius: 5px

                &:before
                  content: attr(data-index)
                  display: inline-block
                  background: map-get($colors, primary)
                  width: 20px
                  height: 20px
                  border-radius: 100%
                  font-size: 16px
                  color: #fff
                  text-align: center
                  margin-right: 10px
                  line-height: 20px
                  position: relative
                  top: -1px

                &.-active
                  color: #fff

                  &:after
                    background: map-get($colors, primary)

                  &:before
                    background: #fff
                    color: map-get($colors, primary)

            .arrows-mobile
              display: none

      .-swiper
        overflow: hidden

        figure
          overflow: hidden

          div
            background: map-get($colors, gray)

            img
              display: block
              // min-width: 80vw
              // width: 100%
              height: auto
              max-height: calc(100vh - 150px)
              // max-width: 85vw
              // max-height: 75vh
              // height: auto
              width: auto
              margin: 0 auto

      .caption
        background: #313131
        padding: 14px 30px 12px
        border-radius: 0px 0px 12px 12px
        text-align: center
        overflow: hidden
        line-height: 21px

        p
          display: block
          font-size: 19px
          color: #fff

  @media (max-width: 1024px)
    .emp-modal

      .content
        // width: 100%
        max-width: 98vw
        max-height 90vh

        &.-regua
          width: 96vw

          .content-modal
            padding: 0 20px 20px

            h3
              font-size: 20px

            p
              font-size: 15px

        .-swiper
          $sizeSquare: 100px
          $sideSpaces: 40px

          .btn
            width: $sizeSquare
            height: $sizeSquare
            border-radius: 10px

            &:before
              content: ''
              background-image: url(~/images/icons/arrow-left-blue.png)
              background-size: contain
              background-repeat: no-repeat
              width: 30px
              height: 47px
              position: absolute

            &.btn-prev
              left: calc(#{$sideSpaces} - 100px)

              &:before
                top: 5%
                left: 58%

            &.btn-next
              right: calc(#{$sideSpaces} - 100px)

              &:before
                top: 48%;
                left: 13%;

        .content-modal
          overflow-y: auto

          .btn
            width: 60px !important
            height: 66px !important
            background-color: transparent
            top: 50%
            transform: rotate(0) translateY(-50%)
            border-radius: 0

            &:before
              transform: rotate(0) translate(-50%, -50%) !important
              top: 50% !important
              left: 50% !important

            &.btn-prev
              left: 0

            &.btn-next
              right: 0

              &:before
                transform: rotate(0) translate(-50%, -50%) scaleX(-1) !important
                filter: FlipH
                -ms-filter: 'FlipH'

          &.-plant
            max-height: calc(80vh - 75px)

            .tabs
              a
                width: 100%
                max-width: initial

            .info
              display: block

              .-swiper
                width: 100%

                figure div
                  p
                    width: 20px
                    height: 20px
                    font-size: 15px
                    line-height: 20px

              .list-items
                width: 100%
                display: flex
                flex-wrap: wrap

                li
                  width: 100%
                  flex: 0 calc(50% - 10px)
                  margin: 0 5px
                  font-size: 14px
                  padding: 9px 6px 9px

              .arrows-mobile
                display: block
                text-align: center

                a
                  display: inline-block
                  width: 40px
                  height: 80px
                  margin: 0 7px
                  background-image: url(~/img/icons/btn-right-triangle-blue.png)
                  background-repeat: no-repeat
                  background-position: center
                  background-size: contain

                  &.btn-prev
                    transform: rotate(180deg)
</style>
